module.exports = "<a ng-click=\"generateReportCtrl.generateReport()\" class=\"li-a-p {{ generateReportCtrl.elementClasses }}\" href=\"\">\n  {{generateReportCtrl.reportName || 'Generate Report'}}\n</a>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/generateReports/template.a.html
// module id = 1356
// module chunks = 0